import { Component, OnInit } from '@angular/core';
import { Group } from '@microsoft/microsoft-graph-types-beta';
import { first, map, Observable, skipUntil } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { BaseComponent } from '../../../base/base.component';
import { initAuthenticationMethodsEmailOTPForm } from 'projects/angular-clarity/src/app/modules/sway/tools/schemas/graph/authentication-method-policy/email-otp/form';
import { updateAuthenticationMethodsEmailOTPSchema } from 'projects/angular-clarity/src/app/modules/sway/tools/schemas/graph/authentication-method-policy/email-otp/schema';
import { client } from 'projects/angular-clarity/src/app/stores/client';
import { EmailAuthenticationMethodConfigurationForm } from 'projects/angular-clarity/src/app/modules/sway/tools/schemas/graph/authentication-method-policy/email-otp/model';

@Component({
    selector: 'app-baseline',
    templateUrl: './baseline.component.html',
    styleUrls: ['./baseline.component.scss', '../../../styles/baseline-style.scss'],
})
export class BaselineComponent extends BaseComponent implements OnInit {
    groups$: Observable<Map<string, Group>>;
    constructor(private store: Store<any>) {
        super();
    }
    ngOnInit(): void {
        this.groups$ = this.store
            .pipe(select(client(this.tenant_id).graph.groups.all))
            .pipe(skipUntil(this.store.pipe(select(client(this.tenant_id).graph.groups.loaded))))
            .pipe(
                map((groups) => {
                    return new Map(groups.map((group) => [group.id, group]));
                }),
            );

        const schema = JSON.parse(JSON.stringify(this.baseline.schema));
        this.form = initAuthenticationMethodsEmailOTPForm(schema);

        this.form.valueChanges.subscribe((_) => {
            const form = this.formValue;
            const updatedSchema = updateAuthenticationMethodsEmailOTPSchema(form);

            if (this.form.invalid) {
                this.baselineErrorChange.next({ remediate: true, save: true });
            } else {
                this.baselineErrorChange.next({ remediate: false, save: false });
            }

            this.baselineChange.next({
                ...this.baseline,
                schema: JSON.parse(JSON.stringify(updatedSchema)),
            });
        });
    }

    get formValue(): EmailAuthenticationMethodConfigurationForm {
        return this.form.getRawValue();
    }
}
